import { render, staticRenderFns } from "./trainAuthorizeAgreement.vue?vue&type=template&id=76106d34&scoped=true&"
import script from "./trainAuthorizeAgreement.vue?vue&type=script&lang=js&"
export * from "./trainAuthorizeAgreement.vue?vue&type=script&lang=js&"
import style0 from "./trainAuthorizeAgreement.vue?vue&type=style&index=0&id=76106d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76106d34",
  null
  
)

export default component.exports